import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./Context/AuthContext/AuthContext";
import { AppProvider } from "./Context/AppContext/AppContext";
import { ModalProvider } from "./Context/ModalContext/Index";
import { AILoaderProvider } from "./Context/AILoaderContext/AILoaderContext";
import { LoaderProvider } from "./Context/LoaderContext/LoaderContext";
import "./index.scss";
import App from "./App";

// Configure Monaco Editor worker path
if (typeof window !== 'undefined') {
  (window as any).MonacoEnvironment = {
    getWorkerUrl: function (_moduleId: string, label: string) {
      if (label === 'json') {
        return 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs/language/json/json.worker.js';
      }
      if (label === 'css' || label === 'scss' || label === 'less') {
        return 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs/language/css/css.worker.js';
      }
      if (label === 'html' || label === 'handlebars' || label === 'razor') {
        return 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs/language/html/html.worker.js';
      }
      if (label === 'typescript' || label === 'javascript') {
        return 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs/language/typescript/ts.worker.js';
      }
      return 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs/base/worker/workerMain.js';
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <AuthProvider>
      <AppProvider>
        <LoaderProvider>
          <AILoaderProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </AILoaderProvider>
        </LoaderProvider>
      </AppProvider>
    </AuthProvider>
  </HelmetProvider>
);
